import React, { Fragment, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { staffLogout } from '../../actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import { SidebarLogo, SidebarNavList } from '../common/SidebarNav';
import { BillingGapsBadge } from '../HR/BillingGapsWorklist';
import '../HR/hrSidebar.css';
import BpGuide from '../common/BpGuide';

export const DOCTOR_DASHBOARD = { to: '/doctor/dashboard', icon: 'fas fa-home', color: '#F6D55C', label: 'My Dashboard' };

const Sidebar = (props) => {

    const { isAuthenticated } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
		
		if(isAuthenticated === false) {
			props?.history?.push("/login");
		}
	}, [isAuthenticated])


    const logoutHandler = () => {
        dispatch(staffLogout());
    }


    return (
        <Fragment>
            <div className="sidebar hr-white-sidebar">
            <SidebarLogo />

            <SidebarNavList dashboard={DOCTOR_DASHBOARD} badge={<BillingGapsBadge style={{ marginLeft: 6 }} />}>
                <li className="nav_link">
                    <NavLink key="staffpatients" to="/doctor/patients" activeClassName="link-name-active">
                    <i className="fas fa-hospital-user" style={{color: '#ED553B', fontSize: '24px'}}></i>
                        <span className="link_name" title="RPM Patients">RPM Patients</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="staffpatients" to="/CCM/doctor/patients" activeClassName="link-name-active">
                    <i className="fas fa-disease" style={{color: '#2ec4b6', fontSize: '24px'}}></i>
                        <span className="link_name" title="CCM Patients">CCM Patients</span>
                    </NavLink>
                </li>    

                {/* <li className="nav_link">
                    <NavLink key="careplans" to="/doctor/careplan" activeClassName="link-name-active">
                    <i className="fas fa-pencil-alt" style={{color: '1D7874', fontSize: '24px'}}></i>
                        <span className="link_name" title="Careplans">Careplans</span>
                    </NavLink>
                </li> */}

                <li className="nav_link">
                    <NavLink key="timesummaryreport" to="/doctor/report/financialReport" activeClassName="link-name-active">
                    <i className="fas fa-dollar-sign" style={{color: 'green', fontSize: '24px'}}></i>
                        <span className="link_name" title="Time Summary Report">Time Summary Report</span>
                    </NavLink>
                </li>

                <li>
                    <NavLink key="logout" to="#" onClick={logoutHandler}>
                    <i className="fas fa-sign-out-alt" style={{color: 'red', fontSize: '24px'}}></i>
                        <span className="link_name" style={{color: 'red', fontWeight: 'bold'}}>Logout</span>
                    </NavLink>
                </li> 
                <BpGuide />
            </SidebarNavList>
        </div>    
        </Fragment>
    )
}

export default Sidebar;
